<template>
    <div class="auth">
      <center>            
        <div class="TLBrCy">
            <div class="auth-modal">
                <img src="../../assets/hion_logo_positivo.png" width="150" alt="Logo" />
                <hr>
                <div class="auth-title">Login</div>

                <input v-model="log" name="email" type="text" placeholder="E-mail, CPF ou CNPJ">
                <input v-model="usuario.hionacredita" name="password" type="password" placeholder="Senha"
                    v-on:keyup.enter="signin" >

                <button @click.prevent="signin">Entrar</button>
            </div> 
        </div>
      </center>
    </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '../../global'
import { ekarApyaba } from '../../config/piht/cv'

export default {
    name: 'Auth',
    data: function() {
        return {
            usuario: {},
            log: ''
        }
    },
    methods: {
        signin(evt) {                   //Envia requisição para acesso a plataforma
            evt.preventDefault();       //previne comportamento padrao ao clicar no botao entrar

            //Verifica se existe algum dado no campo login e senha /////////////////////////////////////////
            if((this.log === '') || (this.log === undefined) || (this.usuario.hionacredita === '') || 
                (this.usuario.hionacredita === undefined)) {
                    this.$toasted.global.defaultInfo({ msg : 'Para acessar a plataforma insira seu usuário e senha!!!' });
                    return
            } //////////////////////////////////////////////////////////////////////////////////////////////

            this.log  = this.log.toLowerCase(); //garante todas letras minusculas
 
            this.usuario.email = this.semTraco(this.log);       //remove pontos e traços da string Login

            if(!this.usuario.email) {
                this.$toasted.global.defaultInfo({ msg : 'O e-mail informado não é válido!' })
                return  //Caso e-mail inválido, retorna sem enviar a requisição ao db
            }

            axios.post(`${baseApiUrl}/entrar`, this.usuario)    //inicio post axios ///////////////////////
                .then(res => {              
                    //Avalia se a requisicao eh valida ////////////////////////////////////////////////////
                    if (!((res.data.id) && (res.data.cpf_cnpj))) {
                        this.$toasted.global.defaultError({ msg : 'Retorno da requisição inválido!!! Tente novamente!' });
                        return
                    } ////////////////////////////////////////////////////////////////////////////////////

                    ekarApyaba(res.data, this.$router.currentRoute.path);//executa acao de ctrl //////////
                })
                .catch(showError) //final post axios /////////////////////////////////////////////////////
        },
        semTraco(inputData) {
            //se não eh email, então remove os traços e pontos da string
            if (inputData.search("@")==-1) {
                let SoNumero = inputData.replace(/\D/g, '');
                return SoNumero;
            }
            //caso seja um e-mail. executa a validação do mesmo.
            const emailPattern =  /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
            if(emailPattern.test(inputData)) return inputData;
                else return false;
        }
    }
}
</script>

<style>
.auth {
    position: relative;
    background:#008fac;
    color: #2e2d2c;
    height: 100%;
    width: 100%;
}

.TLBrCy {
    padding: 30px 5px;
}

.auth-modal {
    background-color: #2e2d2c;
    width: 300px;
    padding: 35px;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.15);
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.auth-title {
    font-size: 1.2rem;
    font-weight: 100;
    margin-top: 10px;
    margin-bottom: 15px;
    color: #eee;
}

.auth-modal input {
    border: 1px solid #BBB;
    width: 100%;
    margin-bottom: 15px;
    padding: 3px 8px;
    outline: none;
    border-radius: 20px;
    background: #eee;
}

.auth-modal button {
    text-decoration: none;
    background-color: #008fac;
    color: #eee;
    padding: 5px 15px;
    border-radius: 20px;
    border: none;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.15);
    outline:none;
}

.auth-modal hr {
    border: 0;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(to right,
        rgba(120, 120, 120, 0),
        rgba(120, 120, 120, 0.75),
        rgba(120, 120, 120, 0));
}
</style>